let selectedRegistry = null;

const generateAction = {
	id: 'generateAction',
	selectionType: 'single',
	label: 'puiaction.docgen.generate',
	functionality: 'GEN_PUI_DOCGEN',
	checkAvailability: function () {
		return true;
	},
	runAction: function (action, model, registries) {
		selectedRegistry = registries[0];

		const data = { isAction: true, model: model, registry: selectedRegistry };
		this.$puiEvents.$emit(`pui-modalDialogForm-puiDocgenTemplateParameters-${model.name}-show`, data);
	}
};

const downloadTemplateAction = {
	id: 'downloadTemplateAction',
	selectionType: 'single',
	label: 'puiaction.docgen.downloadtemplate',
	functionality: 'WRITE_PUI_DOCGEN',
	checkAvailability: function () {
		return true;
	},
	runAction: function (action, model, registries) {
		selectedRegistry = registries[0];
		const title = this.$puiI18n.t('puiaction.notifyTitle') + ' > ' + this.$puiI18n.t(action.label);

		this.$puiRequests.downloadFileRequest(
			'get',
			model.url.downloadTemplate,
			{ id: selectedRegistry.id },
			(response) => {
				const link = document.createElement('a');
				link.href = window.URL.createObjectURL(new window.Blob([response.data]));
				link.download = selectedRegistry.filename;
				link.click();

				this.$puiEvents.$emit(`onPui-action-running-ended-${model.name}`);
				selectedRegistry = null;
			},
			() => {
				this.$puiEvents.$emit(`onPui-action-running-ended-${model.name}`);
				const message = this.$puiI18n.t('puiaction.notifyError');
				this.$puiNotify.error(message, title);
			}
		);
	}
};

const downloadSampleTemplateAction = {
	id: 'downloadSampleTemplateAction',
	selectionType: 'general',
	label: 'puiaction.docgen.downloadsampletemplate',
	functionality: 'WRITE_PUI_DOCGEN',
	checkAvailability: function () {
		return true;
	},
	runAction: function (action, model) {
		const title = this.$puiI18n.t('puiaction.notifyTitle') + ' > ' + this.$puiI18n.t(action.label);

		this.$puiRequests.downloadFileRequest(
			'get',
			model.url.downloadSampleTemplate,
			null,
			(response) => {
				const link = document.createElement('a');
				link.href = window.URL.createObjectURL(new window.Blob([response.data]));
				link.download = this.$puiUtils.getFilenameFromHeaders(response.headers);
				link.click();

				this.$puiEvents.$emit(`onPui-action-running-ended-${model.name}`);
			},
			() => {
				this.$puiEvents.$emit(`onPui-action-running-ended-${model.name}`);
				const message = this.$puiI18n.t('puiaction.notifyError');
				this.$puiNotify.error(message, title);
			}
		);
	}
};

const uploadNewTemplateAction = {
	id: 'uploadNewTemplateAction',
	selectionType: 'single',
	label: 'puiaction.docgen.uploadnewtemplate',
	functionality: 'WRITE_PUI_DOCGEN',
	checkAvailability: function () {
		return true;
	},
	runAction: function (action, model, registries) {
		selectedRegistry = registries[0];
		selectedRegistry.isAction = true;
		this.$puiEvents.$emit('pui-modalDialogForm-uploadNewTemplate-' + model.name + '-show', selectedRegistry);
	}
};

export default {
	actions: [generateAction, downloadTemplateAction, downloadSampleTemplateAction, uploadNewTemplateAction]
};
